import axios from "axios";
import { toastr } from "react-redux-toastr";
import { reset as resetForm, initialize } from "redux-form";
import { showTabs, selectTab } from "../common/tab/tabActions";
import util from '../consts'
const BASE_URL = util.API_URL;

const INITIAL_VALUES = {
}


export function getList(tipo = "", valor = "",unidades, offset = 0, limit = 16) {
    const request = axios.get(`${BASE_URL}/carnes`, {
        headers: {
            tipo,
            valor,
            offset,
            limit,
            unidades
        }
    })
    return {
        type: 'CARNE_FETCHED',
        payload: request
    }
}

export function create(values) {
    return dispatch => {
        axios['post'](`${BASE_URL}/carne`, values)
            .then(resp => {
                toastr.success('Sucesso', 'Operação Realizada com sucesso.')
                dispatch(initFormCreat())
            }).catch(e => {
                if (e.response === undefined) {
                    toastr.error('Erro', e.message)
                } else {
                    e.response.data.errors.forEach(error => toastr.error('Erro', error))
                }
            })
    }
}

export function retornoParcelas (data){
    return { type: 'CARNE_SEARCH_PARC',
    payload: data}
}

export function buscarParcelas(param) {
    let values = { id_cliente: param === '' ? 0 : param  }
    return dispatch => { axios['post'](`${BASE_URL}/getParcelas`, values)
        .then(resp => {
          
            dispatch( retornoParcelas(resp))
        }).catch(e => {
            if (e.response === undefined) {
                toastr.error('Erro', e.message)
            } else {
                e.response.data.errors.forEach(error => toastr.error('Erro', error))
            }
            dispatch( retornoParcelas({data:{parcelas:[],cliente:{}}}))
        })}

}

export async function imprimir(values) {

    return dispatch => {
        axios['get'](`${BASE_URL}/printCarne`, {
            headers: {
                idcarne: values.id,
                idunidade: values.unidade_id,
                'Accept': 'application/pdf',
            }, responseType: 'arraybuffer'
        })
            .then(resp => {
                const url = window.URL.createObjectURL(new Blob([resp.data], { type: 'application/pdf' }));
                window.open(url, "_blank");
            }).catch(e => {
                if (e.response === undefined) {
                    toastr.error('Erro', e.message)
                } else {
                    e.response.data.errors.forEach(error => toastr.error('Erro', error))
                }
            })

    }
}

export function sendCarne(values) {
    return dispatch => {
        axios['post'](`${BASE_URL}/carne/registrar`, values)
            .then(resp => {
                toastr.success('Sucesso', 'Operação Realizada com sucesso.')
                dispatch(initFormCreat())
            }).catch(e => {
                if (e.response === undefined) {
                    toastr.error('Erro', e.message)
                } else {
                    e.response.data.errors.forEach(error => toastr.error('Erro', error))
                }
            })
    }
}

export function update(values) {
    return submit(values, 'put')
}

export function remove(values) {
    return submit(values, 'put')
}

function submit(values, method) {
    return dispatch => {
        axios[method](`${BASE_URL}/carne`, values)
            .then(resp => {
                toastr.success('Sucesso', 'Operação Realizada com sucesso.')
                dispatch(initFormCreat())
            }).catch(e => {
                if (e.response === undefined) {
                    toastr.error('Erro', e.message)
                } else {
                    e.response.data.errors.forEach(error => toastr.error('Erro', error))
                }
            })
    }
}

export function showUpdate(carne) {

    return [
        showTabs('tabUpdate'),
        selectTab('tabUpdate'),
        initialize('carneForm', carne)
    ]
}

/* TODO refatorar para utilizar um metodo so com o showupdate*/
export function showDelete(carne) {
    return [
        showTabs('tabDelete'),
        selectTab('tabDelete'),
        initialize('carneForm', carne)
    ]
}

export function init() {
    return [
        showTabs('tabList', 'tabCreate'),
        selectTab('tabList'),
        getList(),
        initialize('carneForm', INITIAL_VALUES)
    ]
}


export function clearFormCreat (){
    return { type: 'CARNE_CLEAR_FORM_CREAT',
    payload: ''}
}

export function initFormCreat() {
    return [
        showTabs('tabList', 'tabCreate'),
        selectTab('tabList'),
        getList(),
       clearFormCreat()
    ]
}


// WEBPACK FOOTER //
// ./src/carne/carneAction.js